import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = { id: Number }
  static targets = ["currentFile", "progress", "progressBar", "archiveSpinner"]

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "ProcessingChannel", processing_id: this.idValue },
      {
        connected: () => this.requestArchiveStatus(),
        received: (data) => this.handleMessage(data)
      }
    )
  }

  // Архив мог собраться раньше, чем страница подписалась на канал, —
  // тогда спиннер ZIP висел бы до ручной перезагрузки (ArchiveStatusAction).
  requestArchiveStatus() {
    if (this.hasArchiveSpinnerTarget) this.subscription?.perform("archive_status")
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleMessage(data) {
    console.log("Processing message received:", data)
    switch(data.type) {
      case "progress":
        this.updateProgress(data)
        break
      case "error":
        this.showError(data.error)
        break
      case "archive_status":
        this.updateArchiveStatus(data)
        break
    }
  }

  updateArchiveStatus(data) {
    console.log("Archive status received on processing page:", data)
    // Only reload or update if it's the main processing zip for this page
    if (data.kind === "processing_zip" && (data.state === "ready" || data.state === "error")) {
      console.log("Reloading page due to archive status...")
      window.location.reload()
    }
  }

  updateProgress(data) {
    if (this.hasCurrentFileTarget) {
      this.currentFileTarget.textContent = data.current_file || ""
    }
    if (this.hasProgressTarget) {
      this.progressTarget.textContent = `${data.files_done} / ${data.total_files}`
    }
    if (this.hasProgressBarTarget && data.total_files > 0) {
      const percent = Math.round((data.files_done / data.total_files) * 100)
      this.progressBarTarget.style.width = `${percent}%`
    }
    
    // Reload page if finished
    if (data.state === "finished" || data.state === "error") {
      window.location.reload()
    }
  }

  showError(error) {
    console.error("Processing error:", error)
  }
}
